export default "/images/vendor/flag-icon-css/flags/1x1/bm.svg?728fd219af713f367b10c1fef541fafa";